/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  MenuItem,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Close";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import {
  getDateFormatInSpanish,
  mergeListById,
} from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import TemperatureHeader from "./Header/TemperatureHeader"; // Changed from BloodPressureHeader
import VitalCommonheader from "../Common/Header/VitalCommonheader";
import SaveTemperaturePopup from "./Popup/SaveTemperaturePopup"; // Changed from SaveBloodPressurePopup

const TemperatureBody = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [temperatureList, setTemperatureList] = useState([]); // Changed from bloodPressureList
  const [rowSelection, setRowSelection] = useState({});
  const [selectedTemperatureIds, setSelectedTemperatureIds] = useState([]); // Changed from selectedBloodPressureIds
  const [selectedTemperatureId, setSelectedTemperatureId] = useState(null); // Changed from selectedBloodPressureId

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get all temperature
  const getAllTemperature = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TEMPERATURE; // Changed API URL

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        const { listrecords } = response.data;
        setTemperatureList(listrecords); // Changed from setBloodPressureList
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //update temperature
  const updateBulkTemperatureHandler = async () => {
    if (selectedTemperatureIds.length > 0) {
      try {
        const temperatureListToBeUpdate = temperatureList.filter((item) =>
          selectedTemperatureIds.includes(item._id)
        );

        let temperatureData = {
          temperaturelist: temperatureListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_TEMPERATURE + // Changed API URL
          ``;

        const response = await putData(requestURL, temperatureData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedTemperatureIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one temperature");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //delete temperature
  const deleteBulkTemperatureHandler = async () => {
    if (selectedTemperatureIds.length > 0) {
      try {
        const temperatureListToBeDelete = temperatureList.filter((item) =>
          selectedTemperatureIds.includes(item._id)
        );

        let temperatureData = {
          temperaturelist: temperatureListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_TEMPERATURE + // Changed API URL
          ``;

        const response = await putData(requestURL, temperatureData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setTemperatureList((prevList) =>
              prevList.filter(
                (item) => !selectedTemperatureIds.includes(item._id)
              )
            );

            setSelectedTemperatureIds([]);
            setRowSelection({});
          }, 1500);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one temperature");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const afterActionClose = (data = []) => {
    setTemperatureList((prevList) => mergeListById(prevList, data)); // Changed from setBloodPressureList
  };

  useEffect(() => {
    getAllTemperature(); // Changed from getAllBloodPressure
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveTemperatureOffCanvas" // Changed from #saveBloodPressureOffCanvas
            aria-controls="saveTemperatureOffCanvas" // Changed from saveBloodPressureOffCanvas
            onClick={() => {
              setSelectedTemperatureId(row.original._id); // Changed from setSelectedBloodPressureId
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Celsius",
        accessorKey: "celcius",
        size: 200,
      },
      {
        header: "Fahrenheit",
        accessorKey: "fahrenheit",
        size: 200,
      },
      {
        header: "Date",
        accessorKey: "date",
        Cell: ({ row }) => <p>{getDateFormatInSpanish(row.original.date)}</p>,
      },
      {
        header: "Assigned To",
        accessorKey: "username",
        size: 300,
        Cell: ({ row }) => (
          <div
            className={
              row.original.username === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.userimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.userimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.username}</span>
            </p>
          </div>
        ),
      },
    ],
    []
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedTemperatureIds(selectedIdsArray); // Changed from setSelectedBloodPressureIds
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_APPOINTMENT_MANAGEMENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper crm-conversation-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Vitals")}
          />
          <div className="container-fluid px-lg-5">
            <TemperatureHeader // Changed from BloodPressureHeader
              selectedItemIds={selectedTemperatureIds} // Changed from selectedBloodPressureIds
              updateBulkHandler={updateBulkTemperatureHandler} // Changed from updateBulkBloodPressureHandler
              reloadList={getAllTemperature} // Changed from getAllBloodPressure
            />
            <VitalCommonheader activeOption="temperature" />{" "}
            {/* Changed activeOption */}
            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={temperatureList} // Changed from bloodPressureList
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* modal and popup section  */}

          <SaveTemperaturePopup // Changed from SaveBloodPressurePopup
            selectedTemperatureId={selectedTemperatureId} // Changed from selectedBloodPressureId
            setSelectedTemperatureId={setSelectedTemperatureId} // Changed from setSelectedBloodPressureId
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <AssignUserModal
            moduleName="temperature" // Changed moduleName
            afterModalClose={afterActionClose}
            selectedIds={selectedTemperatureIds} // Changed from selectedBloodPressureIds
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedTemperatureIds([]); // Changed from setSelectedBloodPressureIds
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkTemperatureHandler} // Changed from deleteBulkBloodPressureHandler
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedTemperatureIds([]); // Changed from setSelectedBloodPressureIds
            }}
            moduleName={t("temperature")} // Changed moduleName
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default TemperatureBody;
